import requests from "./httpService";

// Notes module (personal notes, /api/v1/notes). Not the task/lead comments, which TaskServices
// and CrmLeadsServices also call "notes". Company and user come from the login token.
const query = (params = {}) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

const UserNotesServices = {
  getNotes(params) {
    return requests.get(`/notes/all?${query(params)}`);
  },
  getDeletedNotes(params) {
    return requests.get(`/notes/deleted?${query(params)}`);
  },
  getTags(q = "") {
    return requests.get(`/notes/tags?${query({ q })}`);
  },
  // the people linked on notes the user can see (the People filter)
  getLinkedPeople() {
    return requests.get(`/notes/linked-people`);
  },
  createNote(body) {
    return requests.post(`/notes/create`, body);
  },
  updateNote(id, body) {
    return requests.post(`/notes/update/${id}`, body);
  },
  archiveNote(id, archived) {
    return requests.post(`/notes/archive/${id}`, { archived });
  },
  // tick a note done (Completed tab) or bring it back
  completeNote(id, completed) {
    return requests.post(`/notes/complete/${id}`, { completed });
  },
  deleteNote(id) {
    return requests.delete(`/notes/delete/${id}`);
  },
  restoreNote(id) {
    return requests.post(`/notes/restore/${id}`);
  },
  // links a note to the task created from it (the task itself is created through TaskServices)
  promoteNote(id, taskId) {
    return requests.post(`/notes/promote/${id}`, { task_id: taskId });
  },
  getNotesFromTask(taskId) {
    return requests.get(`/notes/from-task/${taskId}`);
  },
};

export default UserNotesServices;
